import React from "react";
import { PhoneOff } from "lucide-react";
import { voiceAgentActions } from "../../../../../store/voiceAgentStore";

interface EndSessionButtonProps {
  className?: string;
}

const EndSessionButton: React.FC<EndSessionButtonProps> = ({
  className = "",
}) => {
  const stopSession = voiceAgentActions.stopSession;

  return (
    <button
      onClick={stopSession}
      className={`py-3 px-6 rounded-full flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 text-white font-semibold shadow-lg transition-all duration-300 ${className} cursor-pointer`}
    >
      <PhoneOff className="h-5 w-5" />
      <span className={`text-sm`}>End Session</span>
    </button>
  );
};

export default EndSessionButton;
